import React from 'react';
import DeviceManagementPage from 'app/routes/settings/DeviceManagementPage';
import AuthProtectedPage from 'app/routes/auth/AuthProtectedPage';
import {useSelector} from 'react-redux';
import {selectAuthState, selectFetchStates} from 'app/hooks/reduxCreateSelectorHooks';

const DeviceManagementWrapperPage = props => {
  const {devicesFetched} = useSelector(selectFetchStates);
  const isAuthenticated = useSelector(selectAuthState);
  return isAuthenticated && devicesFetched ? (
    <DeviceManagementPage />
  ) : (
    <AuthProtectedPage loading={props.initializing || (isAuthenticated && !devicesFetched)} />
  );
};

export default DeviceManagementWrapperPage;
